module.exports = __webpack_public_path__ + "img/gif.4569d8ff.gif";